export const logFilesOnly = (assets) => (
  Object.entries(assets)
    .filter(([key, value]) => (
      !['video', 'video.mp4', 'screenshots'].includes(key) && value
    ))
);

export default { logFilesOnly };
